"use strict";

exports.__esModule = true;
var _LayoutThumbnail = require("./LayoutThumbnail");
Object.keys(_LayoutThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LayoutThumbnail[key]) return;
  exports[key] = _LayoutThumbnail[key];
});